<script>
import $ from 'domtastic';
import eventHub from 'viralstyle-ui/src/eventHub';
import storage from 'viralstyle-ui/src/storage';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';
import hateoas from 'viralstyle-ui/src/hateoas';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VueScript2 from 'vue-script2';
import VsToaster from 'viralstyle-ui/src/VsToaster';
import { mapState } from 'vuex';

import config from 'config';
import LayoutHeader from 'components/Header';
import LayoutFooter from 'components/Footer';
import CollectionsMenu from 'components/CollectionsMenu';
import StyleSheet from '@/directives/StyleSheet';

export default {
  components: {
    VsToaster,
    LayoutHeader,
    LayoutFooter,
    CollectionsMenu,
  },
  directives: {
    StyleSheet,
  },
  mixins: [vueMixins],
  data: () => ({
    cartInitialized: false,
  }),
  computed: {
    ...mapState(['ready', 'lockScroll', 'notifications', 'domainConfig', 'searchApplied', 'collections', 'campaignErrorInfo']),
    ...mapState({
      campaign: state => state.sales.campaign,
      cart: state => state.cart.cart,
    }),
    onSalesPage() {
      return this.$route.name === 'sales';
    },
  },
  watch: {
    $route(to, from) {
      let toAndFromCollection = to.name === 'collection' && from.name === 'collection';

      if (this.ready) {
        this.$_viewPage();
      }

      if (to.name === 'home' && from.name === 'products') {
        this.updateState(this.$store.state, 'search', null);
        this.updateState(this.$store.state, 'searchApplied', false);
        this.$store.dispatch('getCampaigns', { page: 1, redirect: this.searchApplied });
      }

      if (to.name === 'sales' && this.cartInitialized) {
        this.$_storeAffiliate();
      }

      if ((!this.onSalesPage || (this.onSalesPage && to.hash === from.hash)) && !toAndFromCollection) {
        window.scrollTo(0, 0);
      }
    },
  },
  async created() {
    await this.$store.dispatch('getApiRoutes');

    await Promise.all([
      this.$store.dispatch('getSiteConfig'),
      this.$store.dispatch('getCollections'),
    ]);

    this.$_viewPage();

    this.$store.dispatch('getCurrencyInfo')

    this.$store.commit('applicationReady', true);

    if (this.$route.name === 'cart' && this.$route.params.id) {
      storage.set('cart', hateoas.url('get_cart', { cartId: this.$route.params.id }));
    }

    if (storage.get('cart') && !this.cart.items.length) {
      try {
        await this.$store.dispatch('getCart');

        this.$_storeAffiliate();

        if (!this.cart.items.length) {
          this.applyUrlCoupon();
        }
      } catch (e) {
        if (this.$route.name === 'checkout' || this.$route.name === 'cart') {
          this.$store.dispatch('navigateToRecentCampaignOrMarketplace');
        }

        this.$_storeAffiliate();
      }
    } else {
      this.$_storeAffiliate();
    }

    this.$_appendGrecaptcha();
  },
  mounted() {
    $(document.body).on('keyup', this.handleEscPressed);
  },
  beforeDestroy() {
    $(document.body).off('keyup', this.handleEscPressed);
  },
  methods: {
    $_viewPage() {
      let excludedRoutes = ['home', 'products', 'sales', 'thankYou', 'collection'],
        excludeNonGa = ['checkout', 'cart'];

      if (get(this.$route, 'name') && !excludedRoutes.includes(this.$route.name)) {
        this.$store.dispatch('viewPage', excludeNonGa.includes(this.$route.name));
      }
    },
    $_appendGrecaptcha() {
      if (config.GOOGLE_RECAPTCHA_SITEKEY) {
        VueScript2.load('https://www.google.com/recaptcha/api.js?onload=grecaptchaLoaded&render=explicit');

        window.grecaptchaLoaded = () => this.$store.commit('updateState', { object: this.$store.state, property: 'grecaptchaLoaded', value: true });
      }
    },
    $_storeAffiliate() {
      if (this.$route.name === 'sales') {
        if (!this.cart.items.length) {
          let affiliateObj = storage.get('affiliate'),
            affiliateId = this.$route.query.aid;

          if (affiliateId) {
            storage.set('affiliate', { aid: affiliateId }, { storages: ['cookie'], expireDays: 60 });
          }
        }

        let query = cloneDeep(this.$route.query);

        delete query.aid;

        this.$router.replace({ name: 'sales', query, params: this.$route.params, hash: this.$route.hash }).catch(err => {});
      }

      this.cartInitialized = true;
    },
    handleEscPressed(e) {
      if (e.keyCode === 27) eventHub.$emit('esc-pressed');
    },
    handleRemoveNotification(notification) {
      this.$store.commit('removeNotification', notification);
    },
  },
  metaInfo() {
    if (this.domainConfig) {
      let meta = [],
        link = [];

      link.push({ rel: 'shortcut icon', href: this.domainConfig.assets.favicon });

      if (this.domainConfig.about) {
        let content = this.domainConfig.about.replace(/<[^>]+>/gm, ' ').replace(/\s{2,}/g, ' ').replace('&nbsp;', ' ').trim();

        meta.push({ name: 'description', content });

        if (!this.onSalesPage) {
          meta.push({ property: 'og:description', content });
          meta.push({ property: 'twitter:description', content });
        }
      }

      if (this.domainConfig.meta.google_site_verification) {
        meta.push({ name: 'google-site-verification', content: this.domainConfig.meta.google_site_verification });
      }

      if (this.domainConfig.meta.fb_domain_verification) {
        meta.push({ name: 'facebook-domain-verification', content: this.domainConfig.meta.fb_domain_verification });
      }

      if (!this.onSalesPage) {
        let image = this.domainConfig.assets.logo || this.domainConfig.assets.banner;

        meta.push({ property: 'og:url', content: window.location.href });
        meta.push({ property: 'og:image', content: image });
        meta.push({ property: 'og:title', content: this.domainConfig.company_name });
        meta.push({ name: 'twitter:card', content: 'summary' });
        meta.push({ name: 'twitter:url', content: window.location.href });
        meta.push({ name: 'twitter:title', content: this.domainConfig.company_name });
        meta.push({ name: 'twitter:image', content: image });
      }

      return {
        titleTemplate: titleChunk => titleChunk ? `${titleChunk} - ${this.domainConfig.company_name}` : this.domainConfig.company_name,
        meta,
        link,
      };
    }
  },
};
</script>

<template lang='pug'>
.wrapper.font-archivo.relative.text-brand-secondary.overflow-x-hidden(
  v-if='ready',
  v-style-sheet='',
)
  layout-header
  collections-menu(v-if='collections && collections.length')
  main#content
    router-view
  layout-footer(ref='footer')
  vs-toaster(:notifications='notifications', @remove-toast='handleRemoveNotification')
  .csid(v-if='$route.name === "sales"')
    small(v-if='campaign.products.length') {{campaign.analytics_cid}}
    small(v-else-if='campaignErrorInfo') {{campaignErrorInfo.campaign_id}}
</template>

<style>
@import '~import/index';

html {
  font-size: 12px;

  @media (min-width: 768px) {
    font-size: 13px;
  }

  @media (min-width: 1024px) {
    font-size: 14px;
  }

  @media(min-width: 1280px) {
    font-size: 16px;
  }
}

#content {
  min-height: 90vh;
}

.absolute {
  &--center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &-vertical {
      top: 50%;
      transform: translateY(-50%);
    }

    &-horizontal {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.no-scroll {
  overflow: hidden;
  -webkit-overflow-scrolling: auto;

  &--mobile {
    overflow: hidden;
    -webkit-overflow-scrolling: auto;

    @include mq(mf-md) {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}

.csid {
  position: absolute;
  color: $white;
  right: .5rem;
  bottom: .5rem;
}

img,
.vs-product-slider__image,
.details-upsell__image,
.campaign__image {
  opacity: 0;
  transition: opacity 500ms;
}

img[lazy=loading],
.vs-product-slider__image[lazy=loading],
.details-upsell__image[lazy=loading],
.campaign__image[lazy=loading] {
  opacity: 1;
}

img[lazy=loaded],
.vs-product-slider__image[lazy=loaded],
.details-upsell__image[lazy=loaded],
.campaign__image[lazy=loaded],
.product-details__tabs img {
  opacity: 1;
}

.vertical-gradient {
  position: absolute;
  top: 0;
  height: 100%;
  width: 2rem;

  &--right {
    right: 0;
    background: linear-gradient(to right, transparent, white);
  }

  &--left {
    left: 0;
    background: linear-gradient(to right, white, transparent);
  }

  @include mq(mf-md) {
    display: none;
  }
}

.loader {
  border-radius: 50%;
  animation: rotation 1.5s infinite linear;
  border-top-color: transparent;

  &.absolute {
    top: 50%;
    left: 50%;
    animation: rotation-absolute 1.5s infinite linear;
  }
}

.break-anywhere {
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  80% {
    transform: rotate(200deg);
  }

  100% {
    transform: rotate(359deg);
  }
}

@keyframes rotation-absolute {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  80% {
    transform: translate(-50%, -50%) rotate(200deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(359deg);
  }
}
</style>